import { H1Mail } from '@e3dc-react/icons'
import { Badge, IconButton } from '@mui/material'
import React from 'react'
import { isFlowTheme } from 'src/Libs/utils'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  headerIcon: {
    '&.MuiSvgIcon-root': {
      width: 35,
      height: 35,
    },
  },
  headerIconActive: {
    backgroundColor: 'inherit',
    borderRadius: '50%',
    '&.MuiSvgIcon-root': {
      width: 35,
      height: 35,
      color: theme.palette.primary.main,
      [theme.breakpoints.down('md')]: {
        width: 35,
        height: 35,
      },
    },
  },
}))

interface Props {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  unreadNotificationsCount: number
  isNotificationPage: boolean
}

/**
 * Displays the notification badge indicating the unread messages
 */
const NotificationBadge: React.VFC<Props> = ({ onClick, unreadNotificationsCount, isNotificationPage }) => {
  const { classes } = useStyles()

  return (
    <IconButton
      sx={{ marginRight: '4px' }}
      color="inherit"
      onClick={isFlowTheme ? undefined : onClick}
      data-qa={'button-header-messages'}
      size="large"
    >
      <Badge badgeContent={isFlowTheme ? undefined : unreadNotificationsCount} color="secondary" overlap="circular">
        <H1Mail className={isNotificationPage ? classes.headerIconActive : classes.headerIcon} />
      </Badge>
    </IconButton>
  )
}

export default NotificationBadge
